import { render, staticRenderFns } from "./Class.vue?vue&type=template&id=2dadf790&scoped=true&"
import script from "./Class.vue?vue&type=script&lang=js&"
export * from "./Class.vue?vue&type=script&lang=js&"
import style0 from "./Class.vue?vue&type=style&index=0&id=2dadf790&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dadf790",
  null
  
)

export default component.exports